import HeroSection from "@/components/Hero/HeroSection.vue";
import NavbarSection from "@/components/Navbar/NavbarSection.vue";
import FooterSection from "@/components/Footer/FooterSection.vue";

export default {
  name: "LandingPage",
  components: {
    NavbarSection,
    HeroSection,
    FooterSection,
  },
};